import React, { ReactElement } from 'react'
import { RadioButton, Stack } from '@mindfulchefuk/design-system'

import sortOptionsConfig, {
  RecipeSortId,
} from '@mindfulchefuk/config/sortOptionsConfig'
import { TOnboardingRecipeFilterHandlers } from '../OnboardingRecipeFilterHandlers.types'

type TOnboardingChooseRecipesSortRadioButtons = {
  onChange: TOnboardingRecipeFilterHandlers['sortBy']
  recipesSortedBy: RecipeSortId
}

export const OnboardingChooseRecipesSortRadioButtons = ({
  onChange,
  recipesSortedBy,
}: TOnboardingChooseRecipesSortRadioButtons): ReactElement => {
  return (
    <Stack spacing={10}>
      {sortOptionsConfig.map(({ id, title }) => {
        const key = `sort-by-${id}`
        return (
          <RadioButton
            id={key}
            key={key}
            data-testid={`${key}-radio`}
            value={id}
            onChange={(event) => onChange(event.target.value as RecipeSortId)}
            checked={id === recipesSortedBy}
          >
            {title}
          </RadioButton>
        )
      })}
    </Stack>
  )
}
